import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { action, makeObservable } from 'mobx';

import ActionsConfiguration, { normalizeActionsConfiguration } from './actions-configuration';
import {
	ActionsConfigurationLevel,
	ActionsConfiguration as ActionsConfigurationEntity
} from '../../../types/common.consts';

export default class InventoryActionsConfiguration extends ActionsConfiguration {
	level = ActionsConfigurationLevel.INVENTORY;

	constructor(actionsConfiguration: ActionsConfigurationEntity) {
		super(actionsConfiguration);

		makeObservable(this, {
			delete: action
		});
	}

	update = () => {
		const updateParams = {
			title: this.title,
			action_data: normalizeActionsConfiguration(this.action_data, this.level)
		};
		return getRootEnv().dashboardSdk.sdk.inventoryActionsConfigurations.update(this.id, updateParams);
	};

	delete = () => {
		return getRootEnv().dashboardSdk.sdk.inventoryActionsConfigurations.delete(this.id);
	};
}
